<template>
  <a-row :gutter="16">
    <a-col :xxl="4" :xl="6" :lg="8" :md="12">
      <a-range-picker v-model:value="queryForm.daterange" :locale="locale" value-format="YYYY-MM-DD"
        style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.orgid" :options="qorgs" :filter-option="$filters.filterOption" show-search
        style="width:100%;">
      </a-select>
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-button type="primary" @click="refresh">查询</a-button>
    </a-col>
  </a-row>
  <div class="static">
    <a-row>
      <a-col :span="5">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">收款金额(¥)</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="收款金额(¥)" :precision="2" :value="total_income" />
      </a-col>
      <a-col :span="5">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">代付金额(¥)</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="代付金额(¥)" :precision="2" :value="total_pay" />
      </a-col>
      <a-col :span="5">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">借款金额(¥)</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="借款金额(¥)" :precision="2" :value="total_loan" />
      </a-col>
      <a-col :span="5">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">利息(¥)</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="利息(¥)" :precision="2" :value="total_interest" />
      </a-col>
      <a-col :span="4">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">剩余金额(¥)</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="剩余金额(¥)" :precision="2" :value="total_left" />
      </a-col>
    </a-row>
  </div>
  <div class="d-flex justify-space-between align-center mb-2">
    <a-space>
      <a-button type="link" @click="refresh">刷新数据</a-button>
    </a-space>
    <a-dropdown>
      <template #overlay>
        <a-menu>
          <a-menu-item @click="exportselected" :disabled="selectedRowKeys.length === 0">导出勾选</a-menu-item>
          <a-menu-item @click="exportall">导出所有页</a-menu-item>
          <a-menu-item @click="exporttask" class="text-error">查看导出任务</a-menu-item>
        </a-menu>
      </template>
      <a-button type="primary">
        导出数据
        <DownOutlined />
      </a-button>
    </a-dropdown>
  </div>
  <a-table bordered size="small" :columns="columns" :data-source="data" :loading="dataLoading"
    :scroll="{ x: width, y: 600 }"
    :pagination="{ current: page, pageSize: limit, total: count, showQuickJumper: true, showSizeChanger: true, showTotal: (total) => `共${total}条`, }"
    @change="(pagination) => { page = pagination.current; limit = pagination.pageSize; }" row-key="_id"
    :row-selection="{ selectedRowKeys, onChange: (keys) => selectedRowKeys = keys }">
    <template #bodyCell="{ record, column }">
      <template v-if="column.dataIndex === 'org'">
        {{ getorgname(record.orgid) }}
      </template>
      <template v-if="column.dataIndex === 'income'">
        {{ $filters.formatMoney(record.income, 2, '') }}
      </template>
      <template v-if="column.dataIndex === 'pay'">
        {{ $filters.formatMoney(record.pay, 2, '') }}
      </template>
      <template v-if="column.dataIndex === 'loan'">
        {{ $filters.formatMoney(record.loan, 2, '') }}
      </template>
      <template v-if="column.dataIndex === 'interest'">
        {{ $filters.formatMoney(record.interest, 2, '') }}
      </template>
      <template v-if="column.dataIndex === 'left'">
        {{ $filters.formatMoney(record.left, 2, '') }}
      </template>
      <template v-if="column.dataIndex === 'operation'">
        <a-a-space>
          <a-button type="link">生成对账单</a-button>
          <a-button type="link">已付款</a-button>
        </a-a-space>
      </template>
    </template>
  </a-table>
</template>
<script setup>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { DownOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { ref, watch, computed, onMounted, onActivated, getCurrentInstance, } from "vue";
import _ from "underscore";
const columns = [
  { title: '编号', dataIndex: 'number', width: 150 },
  { title: '商户名称', dataIndex: 'org', width: 150 },
  { title: '结算周期', dataIndex: 'month', width: 100 },
  { title: '收款金额', dataIndex: 'income', width: 150 },
  { title: '代付金额', dataIndex: 'pay', width: 150 },
  { title: '借款金额', dataIndex: 'loan', width: 150 },
  { title: '利息', dataIndex: 'interest', width: 150, },
  { title: '账户余额', dataIndex: 'left', width: 150, },
  { title: '状态', dataIndex: 'state', width: 100, },//已确认、已打款、已核销
  { title: '结算时间', dataIndex: 'verify_time', width: 150, },
  { title: '备注', dataIndex: 'remark', width: 150, },
  { title: '操作', dataIndex: 'operation', width: 100, fixed: "right" }
];
const { proxy } = getCurrentInstance();

const queryForm = ref({
  daterange: ["", ""],
  orgid: "ALL",
});
const dataLoading = ref(false);
const loading = ref(false);
const page = ref(1);
const limit = ref(20);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const orgs = ref([]);
const selectedRowKeys = ref([]);
const total_income = ref(0);
const total_pay = ref(0);
const total_loan = ref(0);
const total_interest = ref(0);
const total_left = ref(0);

const sorgs = computed(() => orgs.value.map(n => ({ value: n._id, label: n.name })));
const qorgs = computed(() => {
  return [
    { value: 'ALL', label: '全部商户' },
    ...sorgs.value,
  ]
});
const width = computed(() => proxy.$utils.twidth(columns));

watch(() => page.value, () => {
  getData();
});
watch(() => limit.value, () => {
  if (page.value !== 1) page.value = 1;
  else getData();
});

onMounted(() => {
  refresh();
});
const refresh = () => {
  getData();
  getStatistics();
}
const getData = () => {
  dataLoading.value = true;
  proxy.$api.doAPI("/settle/list", { page: page.value, limit: limit.value, ...queryForm.value }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      data.value = _.map(res.data.list, n => {
        return {
          ...n,
          left: proxy.$d(n.income).minus(n.pay).minus(n.loan).minus(n.interest).toFixed(2),
          create_time: proxy.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm'),
        }
      });
      length.value = res.data.length;
      count.value = res.data.count;
      if (length.value > 0 && page.value > length.value) page.value = 1;
      orgs.value = res.data.orgs;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const getStatistics = () => {
  loading.value = true;
  proxy.$api.doAPI("/settle/statistics", { page: page.value, limit: limit.value, ...queryForm.value }).then((res) => {
    loading.value = false;
    if (res.code === 0) {
      total_income.value = res.data.total_income;
      total_pay.value = res.data.total_pay;
      total_loan.value = res.data.total_loan;
      total_interest.value = res.data.total_interest;
      total_left.value = res.data.total_left;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    loading.value = false;
    console.error(err);
  });
};
const exportselected = () => {
}
const exportall = () => {
}
const exporttask = () => {

}
const getorgname = (orgid) => {
  return _.findWhere(orgs.value, { _id: orgid })?.name;
}
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 8px 8px !important;
}

p {
  margin: 0;
  padding: 0;
}

.static {
  padding: 20px;
  background-color: #f2f2f2;
  margin-bottom: 10px;
}
</style>